{
  "translations": {
    "Change Customer Email": "E-Mail-Adressen ändern",
    "Customer Service": "Kundenservice",
    "content": {
      "addressForm": {
        "addName": "Neu",
        "addNameDescription": "Ein privater Nachsendeauftrag kann kostenfrei bis zu {{num}} Namen an derselben Adresse abdecken.",
        "city": "Stadt",
        "cityPlaceholder": "Stadt",
        "country": "Land",
        "countryPlaceholder": "Land",
        "name": "Name",
        "nameForReturns": "Name",
        "nameForSources": "Name",
        "namePlaceholder": "Name",
        "namePlaceholderForReturns": "Vollständiger Name",
        "namePlaceholderForSources": "Vollständiger Name",
        "street": "Straße und Hausnummer",
        "streetPlaceholder": "Straße und Hausnummer",
        "subject": "Betreff",
        "subjectPlaceholder": "Betreff",
        "submitFailed": "Speichern war nicht erfolgreich",
        "validation": {
          "maxCharsN": "Nicht mehr als {{num}} Zeichen",
          "maxNamesN": "Nicht mehr als {{num}} Namen",
          "nChars": "Muss {{num}} Zeichen lang sein",
          "required": "Dies ist ein Pflichtfeld"
        },
        "zip": "PLZ",
        "zipPlaceholder": "PLZ"
      },
      "sourceForm": {
        "addFreeSource": "Jetzt kostenfrei buchen",
        "addSource": "Jetzt für {{value}} € buchen",
        "business": "Geschäftlich",
        "city": "Stadt",
        "cityPlaceholder": "Stadt",
        "country": "Land",
        "countryPlaceholder": "Land",
        "name": "Name",
        "namePlaceholder": "Name",
        "private": "Privat",
        "street": "Straße und Hausnummer",
        "streetPlaceholder": "Straße und Hausnummer",
        "submitFailed": "Speichern war nicht erfolgreich",
        "validation": {
          "nChars": "{{num}} Zeichen erwartet",
          "required": "Dies ist ein Pflichtfeld"
        },
        "zip": "PLZ",
        "zipPlaceholder": "PLZ"
      }
    },
    "customerDetails": {
      "captureChecks": {
        "customerNames": "Kundennamen",
        "publicId": "Public ID"
      },
      "confirm": {
        "close": {
          "body": "Diese Bereiche haben nicht gespeicherte Änderungen, die verloren gehen: {{sections}}",
          "okText": "Verwerfen und schließen",
          "title": "Ohne Speichern schließen?"
        },
        "closeWhileSaving": {
          "body": "Wird noch gespeichert: {{sections}}. Schließen bricht bereits gesendete Schreibvorgänge nicht ab, diese Änderungen können also trotzdem übernommen werden.",
          "cancelText": "Warten",
          "okText": "Trotzdem schließen",
          "title": "Speichern läuft noch"
        },
        "combinedTitle": "Diese Änderungen speichern?",
        "scanCenter": "Scan-Center von {{from}} auf {{to}} ändern?",
        "scheduleOff": "Rücksendeplan abschalten?",
        "scheduleOn": "Rücksende-Intervall auf {{interval}} setzen?"
      },
      "fields": {
        "account": "Konto",
        "automaticTransfer": "Automatische Übertragung",
        "containerIdPlaceholder": "Container-ID",
        "disabledChecks": "Deaktivierte Prüfungen",
        "document": "Dokument",
        "metabaseDashboardId": "Metabase-Dashboard-ID",
        "paywalledSince": "seit {{since}}",
        "retiredScanCenter": "{{scanCenter}} (nicht mehr in Betrieb)",
        "returnsInterval": "Rücksende-Intervall",
        "returnsNextAt": "Nächste Rücksendung am"
      },
      "notifications": {
        "captureSettingsSaved": "Erfassungseinstellungen gespeichert",
        "reportingSaved": "Metabase-Dashboard-ID gespeichert",
        "returnsSaved": "Originale & Rücksendungen gespeichert",
        "saveFailed": "Speichern fehlgeschlagen",
        "scheduleNotSaved": "Scan-Center gespeichert, Rücksendeplan nicht: {{reason}}"
      },
      "returnIntervals": {
        "BI_WEEKLY": "Zweiwöchentlich",
        "DAILY": "Täglich",
        "HALF_YEARLY": "Halbjährlich",
        "MONTHLY": "Monatlich",
        "OFF": "Aus",
        "QUARTERLY": "Vierteljährlich",
        "WEEKLY": "Wöchentlich",
        "YEARLY": "Jährlich"
      },
      "sections": {
        "account": "Konto",
        "actions": "Aktionen",
        "captureSettings": "Erfassungseinstellungen",
        "identity": "Stammdaten",
        "originalsAndReturns": "Originale & Rücksendungen",
        "reporting": "Reporting"
      },
      "status": {
        "saved": "Gespeichert",
        "unsaved": "Nicht gespeicherte Änderungen"
      }
    },
    "customerDocumentActions": {
      "addToReturnBasket": "Zu Rücksendung hinzufügen",
      "errorMessages": {
        "EMPTY_OPEN_RETURN": "Dieser Kunde hat keine Dokumente im Rücksendungs-Korb, es gibt also nichts zu bestellen.",
        "EMPTY_RETURN_ADDRESS": "Für diesen Kunden ist keine Rücksendeadresse hinterlegt, die Rücksendung kann nicht versendet werden.",
        "generic": "Die Rücksendung konnte nicht bestellt werden, bitte erneut versuchen.",
        "RETURN_REQUEST_IN_PROGRESS": "Für diesen Kunden wird bereits eine Rücksendung vorbereitet, eine weitere ist bis zum Abschluss gesperrt.",
        "RETURN_REQUEST_IN_PROGRESS_startedAt": "Für diesen Kunden wird seit {{startedAt}} bereits eine Rücksendung vorbereitet, eine weitere ist bis zum Abschluss gesperrt."
      },
      "noAvailableActions": "Keine aktionen möglich",
      "successMessages": {
        "addToReturnBasket": "Dokument in Rücksendungskorb hinzugefügt",
        "returnSentSuccessfully": "Alle rücksendungen erfolgreich bestellt!",
        "unDelete": "Document wiederhergestellt",
        "unShred": "Zerschreddern rückgängig gemacht"
      },
      "unDelete": "Löschen rückgängig machen",
      "unShred": "Zerschreddern rückgängig machen",
      "waitingForInput": "Gültige Dokument ID eingeben"
    },
    "Delete a document": "Dokumente löschen",
    "Disable Customer": "Kunden deaktivieren",
    "deleteDocuments": {
      "documentDeletedSuccessfully": "Dokument ${documentId} erfolgreich gelöscht",
      "documentDetailPreview": "Dokumentenvorschau",
      "documentReassignedSuccessfully": "Dokument {{documentId}} erfolgreich neu zugewiesen",
      "errorDeletingDocument": "Fehler beim Löschen des Dokuments",
      "errorMessageFatal": "Etwas ist total schiefgelaufen!",
      "errorReassigingDocument": "Fehler beim Neuzuweisen des Dokuments",
      "noDocumentsSelected": "Keine Dokumente ausgewählt",
      "removeDocument": "Dokument löschen",
      "searchDocumentInputLabel": "Document ID eingeben",
      "searchDocumentInputPlaceholder": "Document ID"
    },
    "disableCustomer": {
      "disableAccount": "Benutzerkonto deaktivieren",
      "errorText": "Ups! Ein Fehler ist aufgetreten: ",
      "modalBody": "Bist Du sicher, dass Du diesen Kunden deaktivieren möchtest?",
      "modalTitle": "Bist Du sicher, dass Du diesen Kunden deaktivieren möchtest?",
      "successText": "Kundenzugang wurde erfolgreich deaktiviert"
    },
    "disableCustomerSearchPlaceholder": "Public ID, E-Mail-Adresse, Vorname oder Nachname eingeben, um Kunden zu finden.",
    "documentView": {
      "AutomaticProcess": "AutomaticProcess",
      "addTag": "Tag hinzufügen +",
      "amount": "Betrag",
      "amountInvalid": "Betrag ungültig, evtl. keine Zahl",
      "amountValid": "Betrag gültig",
      "CustomerAndPublicNotFound": "Weder Public ID noch Kundenname gefunden",
      "CustomerNamesNone": "Kein Kundenname extrahiert",
      "CustomerNamesNotFound": "Kundenname nicht gefunden",
      "city": "Stadt",
      "clearPayment": "Zahlungsdaten löschen",
      "customerInfoError": "Fehler beim Laden der Kundendaten",
      "DatabreachWarning": "!!!Mögliche Verletzung der Datensicherheit!!!",
      "email": "E-Mail",
      "fillSender": "Absender ist Empfänger",
      "ibanInvalid": "IBAN ungültig",
      "ibanValid": "IBAN gültig",
      "natifMetadata": {
        "date": {
          "placeholder": "DD.MONTH.YYYY",
          "title": "Datumsstempel"
        },
        "scanId": {
          "placeholder": "123.123.123",
          "title": "Scan-Barcode"
        },
        "title": "Natif-Extraktion"
      },
      "PublicIdFuzzy": "PublicIdFuzzy",
      "PublicIdMoreThanOne": "Mehr als eine Public ID gefunden",
      "PublicIdNone": "Keine Public ID gefunden",
      "PublicIdsDontMatch": "Public ID im Dokument entspricht nicht der Public ID im Dateinamen",
      "payment": "Zahlungsdaten",
      "paymentForm": {
        "amount": {
          "label": "Betrag (EUR,Ct.)",
          "placeholder": "Betrag (EUR,Ct.)"
        },
        "iban": {
          "label": "IBAN",
          "placeholder": "IBAN"
        },
        "recipient": {
          "label": "Zahlungsempfänger",
          "placeholder": "Zahlungsempfänger"
        },
        "reference": {
          "label": "Verwendungszweck (min. 5 / max. 140 Zeichen)",
          "placeholder": "Verwendungszweck (min. 5 / max. 140 Zeichen)"
        },
        "validation": {
          "fieldRequired": "Dies ist ein Pflichtfeld",
          "invalid": {
            "bic": "Ungültige BIC",
            "iban": "Ungültige IBAN"
          },
          "invalidCharsForField": "Ungültige Zeichen, bitte nur A-z, 0-9, +-,.?/ verwenden.",
          "invalidIban": "IBAN ist ungültig",
          "maxCharsN": "Nicht mehr als {{limit}} Zeichen erlaubt",
          "maxDecimalsN": "Nicht mehr als {{precision}} Nachkommastellen",
          "minCharsN": "Sollte länger als {{limit}} Zeichen sein",
          "minNumN": "Sollte länger als {{limit}} Zeichen sein",
          "reservedWord": "Dieses Wort kann nicht verwendet werden",
          "typeNaN": "Bitte geben Sie eine Zahl an"
        }
      },
      "phone": "Telefon Nr.",
      "pleaseCheck": "⚠️ Bitte prüfen!",
      "postCode": "Postleitzahl",
      "previewLimit": "Vorschau begrenzt auf 10 von",
      "publicId": "Public ID",
      "receiver": "Empfänger",
      "reference": "Zahlungsreferenz",
      "scanMetadata": {
        "scanDate": {
          "placeholder": "DD.MONTH.YYYY",
          "title": "Zeitstempel"
        },
        "scanId": {
          "placeholder": "123.123.123",
          "title": "Scan-Barcode"
        },
        "title": "Namenskonvention"
      },
      "sender": "Absender",
      "streetAndNumber": "Straße und Hausnummer",
      "to": {
        "placeholder": "Name des Empfängers",
        "title": "An"
      },
      "transfer": "Übertragen",
      "transferAllDialog": {
        "deletePerm": "Unwiderruflich ausführen",
        "filteredListMessage": "Hiermit werden alle Dokumente aus dieser Ansicht übertragen. Änderungen sind dann nicht mehr möglich!",
        "transferAllDocuments": "Alle Dokumente übertragen"
      },
      "unknown": "Unbekannt",
      "userId": "User ID"
    },
    "emailChangeForm": {
      "updateMailFormButtonLabel": "E-Mail-Adresse aktualisieren",
      "updateMailFormInputPlaceholder": "Neue E-Mail-Adresse"
    },
    "Finished": "Fertig",
    "faultyDocuments": {
      "notifications": {
        "error": "Fehler",
        "filenameChangedDescription": "Gut gemacht! 🎉",
        "filenameChangedTitle": "Dateiname erfolgreich geändert",
        "filenameNotChangedDesc": "Bitte Dateinamen korrigieren",
        "filenameNotChangedTitle": "Dateiname wurde nicht geändert"
      },
      "refetch": "Neu laden",
      "table": {
        "actions": "Aktionen",
        "cancelRename": "Umbenennen abbrechen",
        "filename": "Dateiname",
        "openInNewTab": "<0>{{filename}}</0> in neuem Tab öffnen",
        "rename": "Umbenennen",
        "type": "Fehlertyp"
      }
    },
    "home": {
      "assignTagger": {
        "actionButton": "{{num}} Dokumente abrufen",
        "error": "Etwas ist schiefgelaufen, bitte versuchen Sie es erneut",
        "noAvailableDocuments": "Keine Dokumente zum Taggen verfügbar",
        "success": "Dokumente wurden zugewiesen"
      },
      "documentsFilter": "Dokumente-Filter",
      "failedToFetchDocuments": "Fehler beim Laden der Dokumente",
      "somethingWentWrong": "Etwas ist schiefgelaufen:"
    },
    "Inbox": "Posteingang",
    "Login": "Anmelden",
    "labels": {
      "all": "Alle",
      "cancel": "Abbrechen",
      "clone": "Kopieren",
      "darkMode": "Dunkler Modus",
      "delete": "Löschen",
      "discard": "Verwerfen",
      "filteredCount": "Anzahl Dokumente: {{num}}",
      "filteredOf": "von",
      "filteredText": "",
      "lightMode": "Heller Modus",
      "login": "Anmelden",
      "logout": "Abmelden",
      "no": "Nein",
      "noExtension": "Nicht erweitert",
      "ok": "OK",
      "predictedRecepients": "Ermittelter Empfänger: ",
      "reset": "Zurücksetzen",
      "save": "Speichern",
      "search": "Suchen",
      "searchFor": "Suche nach {{item}}",
      "taggers": "Tagger",
      "unfiltered": "Ungefiltert",
      "yes": "Ja"
    },
    "Mail Forwarding Order": "Nachsendeaufträge",
    "misc": {
      "action": "Aktion",
      "address": "Adresse",
      "companyName": "Firmenname",
      "confirmationDialog": {
        "cancelText": "Nein",
        "okText": "Ja",
        "title": "Bist Du sicher?"
      },
      "contactName": "Ansprechpartner",
      "country": "Land",
      "customerDetails": "Kundendetails",
      "delete": "Löschen",
      "disabled": "Deaktiviert",
      "done": "Fertig",
      "email": "E-Mail",
      "error": "Fehler",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "month": "Monat",
      "months": "Monate",
      "noAddress": "Kunde hat keine Adresse eingegeben",
      "noDateSet": "Klicken für Datum",
      "noExternalId": "<Keine externe ID>",
      "orderReturns": "Nachsendung bestellen",
      "pages": "Seiten",
      "requestedAt": "Angefragt am",
      "returnBasket": "In Rücksendungs-Korb",
      "scanCenter": "Scan-Center",
      "send": "Versenden",
      "success": "Das hat geklappt!",
      "user": "Nutzer"
    },
    "natifErrorReport": {
      "confirmMessage": "Sind Sie sicher, einen Fehlerbericht bzgl. Datenextraktion zu senden?",
      "document": {
        "buttonTitle": "Dokumenten-Fehlerbericht senden"
      },
      "errorMessage": "Fehlgeschlagener Fehlerbericht: {{error}}",
      "successMessage": "Fehlerbericht erfolgreich versendet!",
      "tags": {
        "buttonTitle": "Tag-Fehlerberichte senden"
      }
    },
    "navigationDrawer": {
      "changeCustomerEmail": "E-Mail-Adressen ändern",
      "customerDetails": "Kundendetails",
      "deleteDocuments": "Dokumente löschen",
      "filesWithErrors": "Dokumente mit Fehlern"
    },
    "Password": "Passwort",
    "paywallCustomer": {
      "disableAccount": "Paywall User Account",
      "errorText": "Oops! An error has occurred: ",
      "modalBody": "Do you wish to paywall this customer account?",
      "modalTitle": "Are you sure you want to paywall this customer?",
      "successText": "Customer access has been successfully paywalled",
      "successTitle": "Paywall On",
      "switch": {
        "disabled": "off",
        "enabled": "on",
        "label": "Paywalled"
      },
      "uploadCSV": {
        "button": "Upload paywall CSV",
        "error": {
          "fileFormat": "there were issues with CSV format, check dev console for more information",
          "update": "Some updates failed"
        },
        "success": "All paywall updates were successful"
      }
    },
    "Return": "Rücksendungen",
    "returns": {
      "actions": "Aktionen",
      "count": "# Dokumente",
      "date": "Datum",
      "dhlTrackingUploadCompletedMsg": "DHL Tracking Codes erfolgreich hochgeladen!",
      "emptyCsv": {
        "message": "Keine der geladenen Rücksendungen enthält Dokumente mit einer Scan-ID in diesem Scancenter.",
        "title": "Nichts zu exportieren"
      },
      "finishedBy": "Rücksendungstyp",
      "importingCompleted": "Import abgeschlossen",
      "loadMore": "Mehr laden",
      "noDocuments": "Keine Dokumente in dieser Rücksendung",
      "noReturns": "Keine Rücksendungen",
      "receiver": "Empfänger",
      "returnsCsv": {
        "Ods": "Returns für ODS",
        "Sps": "Returns für SPS",
        "Srz": "Returns für SRZ"
      },
      "sender": "Absender",
      "somethingWentWrongMsg": "Es ist ein Fehler aufgetreten. Bitte importieren Sie die Datei erneut.",
      "subject": "Betreff",
      "uploadTrackingCsvBtnLabel": "DHL Tracking CSV hochladen"
    },
    "Stay Logged In": "Angemeldet bleiben",
    "searchCustomerInputPlaceholder": "Public ID, E-Mail-Adresse, Vorname oder Nachname eingeben, um Kunden zu finden.",
    "sources": {
      "CSVUploadCompleteBody": "The forwardings were updated",
      "CSVUploadCompleteTitle": "Import completed",
      "confirmationModal": {
        "body": "Dieser Nachsendeauftrag soll nicht erweitert werden. Kopieren fortsetzen?",
        "title": "Bitte beachten"
      },
      "duration": "Dauer",
      "endAt": "Enddatum",
      "invalidCSVFile": "Errors in CSV file: check invalid rows in downloaded file",
      "somethingWentWrong": "Etwas ist schiefgelaufen",
      "sourceActions": {
        "activate": "Aktiv setzen",
        "activating": "Activating",
        "cancel": "Beenden",
        "noExtension": "Nicht erweitern",
        "request": "Einrichtung eingeleitet"
      },
      "sourceStages": {
        "Activated": "Aktiv",
        "Activating": "In Einrichtung",
        "Canceled": "Beendet",
        "Cancelling": "Wird beendet",
        "Expired": "Abgelaufen",
        "Expiring": "Expiring",
        "NoExtension": "Nicht erweitert",
        "Renewing": "Renewing",
        "Requested": "Vom Kunden bestellt"
      },
      "startAt": "Startdatum",
      "type": "Typ",
      "uploadCSVButton": "upload CSV",
      "uploadCSVCancellationButton": "upload cancellation CSV"
    },
    "titles": {
      "appTitle": "Posteingang",
      "customerDetails": "Kundendetails",
      "forwardsTitle": "Nachsendeaufträge",
      "returnsTitle": "Rücksendungen"
    },
    "Username": "Benutzername",
    "unPaywallCustomer": {
      "disableAccount": "Remove Paywall For User Account",
      "errorText": "Oops! An error has occurred: ",
      "modalBody": "Dyou wish to remove paywall for this customer account?",
      "modalTitle": "Are you sure you want to remove paywall for this customer?",
      "successText": "Customer access has been successfully enabled",
      "successTitle": "Paywall Off"
    }
  }
}
